import { render, staticRenderFns } from "./PendingCandFeedback.vue?vue&type=template&id=2462c7ca&"
import script from "./PendingCandFeedback.vue?vue&type=script&lang=js&"
export * from "./PendingCandFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports